import React from "react";
import { useNavigate } from "react-router-dom";
import "./../Styles/logout.css";
import { API } from "./../../config/api";
export default function Logout() {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await fetch(API.LOGOUT, {
        method: "POST",
      });
    } catch (err) {
      console.error("Backend logout failed:", err);
    } finally {
      // Clear session
      sessionStorage.removeItem("user");

      // Redirect
      navigate("/");
    }
  };

  const handleCancel = () => {
    const user = JSON.parse(sessionStorage.getItem("user"));

    if (user?.role === "admin") {
      navigate("/admin/dashboard");
    } else {
      navigate("/user/dashboard");
    }
  };

  return (
    <div className="logout-overlay" onClick={handleCancel}>
      <div className="logout-popup" onClick={(e) => e.stopPropagation()}>
        <div className="logout-icon">
          <i className="bi bi-box-arrow-right"></i>
        </div>

        <h3>Are you sure you want to logout?</h3>

        <p>
          You will be logged out of your account and redirected to login page.
        </p>

        <div className="logout-actions">
          <button className="logout-confirm" onClick={handleLogout}>
            Yes, Logout
          </button>

          <button className="logout-cancel" onClick={handleCancel}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
